// Which games this device has been shown How to play for (CLAUDE.md: the How to
// play window).
//
// The window opens by itself the first time a device opens each game — Running
// Order and Call Sheet separately, a shared link included — and never again.
// What remembers it is the device, like everything else the site keeps: a
// `cinemore-` key, so Delete my results and the development Reset clear it with
// the rest, and the window opens by itself again (owner, 12 October).
//
// Storage that is not there is not an error: a private window simply sees the
// window every time it opens a game, which is a first visit every time.
export type HowToPlayGame = 'running-order' | 'call-sheet';

const KEY = 'cinemore-howto-seen';

function seen(): HowToPlayGame[] {
  try {
    const raw = localStorage.getItem(KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

/** True the first time this device opens the game; it is then marked as seen. */
export function firstVisit(game: HowToPlayGame): boolean {
  const list = seen();
  if (list.includes(game)) return false;
  try { localStorage.setItem(KEY, JSON.stringify([...list, game])); } catch { /* not kept */ }
  return true;
}

/** The game a path belongs to, or null for a page that is not a game's. */
export function gameOfPath(path: string): HowToPlayGame | null {
  if (path === '/running-order' || path.startsWith('/running-order/')) return 'running-order';
  if (path === '/call-sheet' || path.startsWith('/call-sheet/')) return 'call-sheet';
  return null;
}
